// Ontario ARRL section boundaries as GeoJSON features.
//
// Internal divides follow real geographic features:
//   ONS/GH divide: Highway 400 / Barrie corridor
//     lon ~-79.69, from Lake Ontario (43.58°N) north to Georgian Bay (44.82°N)
//   GH/ONE divide: Trent-Severn Waterway
//     Lake Ontario at Trenton (-77.58, 44.10) → Peterborough (-78.32, 44.30)
//     → Balsam Lake (-78.85, 44.62) → Port Severn / Georgian Bay (-79.72, 44.82)
//   The two divides meet at essentially the same point on Georgian Bay (~-79.7, 44.82)
//   making GH a wedge shape — apex at Georgian Bay, wide along Lake Ontario.
//
// Outer boundaries use exact Ontario province polygon points where available.
// All coordinates are [longitude, latitude] (GeoJSON standard).

const ONTARIO_SECTION_GEOJSON = {
  type: 'FeatureCollection',
  features: [
    {
      // ONN - Ontario North — fully proven correct, no changes
      type: 'Feature',
      properties: { section: 'ONN', name: 'Ontario North' },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          [-95.1543, 49.5767],
          [-95.1503, 52.8264],
          [-93.6522, 53.7222],
          [-93.2721, 53.9989],
          [-92.6981, 54.4109],
          [-92.6023, 54.4785],
          [-92.4766, 54.5669],
          [-92.3886, 54.6279],
          [-90.8439, 55.6678],
          [-89.3056, 56.6272],
          [-89.1796, 56.8689],
          [-89.0378, 56.8361],
          [-88.8794, 56.8581],
          [-88.6547, 56.6964],
          [-88.49,   56.6422],
          [-88.3536, 56.5533],
          [-87.9756, 56.4375],
          [-87.943,  56.3775],
          [-87.7239, 56.2039],
          [-87.7081, 56.1561],
          [-87.5836, 56.0761],
          [-87.6158, 56.0028],
          [-87.5486, 56.05],
          [-87.3519, 55.9928],
          [-87.3625, 55.9467],
          [-86.9794, 55.9317],
          [-86.9589, 55.9058],
          [-86.4778, 55.8089],
          [-86.2772, 55.7289],
          [-85.9444, 55.6978],
          [-85.5778, 55.5628],
          [-85.3933, 55.4089],
          [-85.1289, 55.3464],
          [-85.1219, 55.3033],
          [-85.2142, 55.2733],
          [-85.3981, 55.1008],
          [-85.3831, 55.063],
          [-85.4239, 54.9906],
          [-85.1942, 55.2442],
          [-85.002,  55.2967],
          [-84.5992, 55.2417],
          [-84.3228, 55.29],
          [-84.0922, 55.2717],
          [-83.9203, 55.3192],
          [-83.73,   55.2594],
          [-83.7369, 55.215],
          [-83.6869, 55.2442],
          [-83.6014, 55.2242],
          [-83.5619, 55.1308],
          [-83.5836, 55.2292],
          [-83.6986, 55.2831],
          [-83.1797, 55.1972],
          [-82.9647, 55.2336],
          [-82.8953, 55.1717],
          [-82.9467, 55.1064],
          [-82.8842, 55.1533],
          [-82.6503, 55.1697],
          [-82.5556, 55.1397],
          [-82.5367, 55.1644],
          [-82.3195, 55.0642],
          [-82.3386, 55.0994],
          [-82.308,  55.1219],
          [-82.3406, 55.1647],
          [-82.2458, 55.1028],
          [-82.2872, 55.0367],
          [-82.255,  54.9753],
          [-82.2708, 54.9314],
          [-82.1953, 54.8447],
          [-82.3589, 54.5003],
          [-82.4411, 54.3617],
          [-82.4342, 54.2094],
          [-82.3628, 54.1436],
          [-82.3814, 54.1189],
          [-82.322,  54.1239],
          [-82.2439, 54.068],
          [-82.13,   53.7992],
          [-82.2167, 53.6039],
          [-82.1147, 53.2736],
          [-82.2506, 53.2119],
          [-82.3017, 52.9611],
          [-82.1017, 52.88],
          [-81.9736, 52.7805],
          [-81.9889, 52.7622],
          [-81.9214, 52.6822],
          [-81.558,  52.4561],
          [-81.553,  52.3525],
          [-81.4781, 52.3022],
          [-81.5614, 52.3164],
          [-81.7475, 52.2514],
          [-81.8225, 52.2544],
          [-81.8836, 52.1875],
          [-81.7583, 52.2394],
          [-81.5017, 52.2333],
          [-81.3528, 52.1011],
          [-80.9883, 52.008],
          [-80.9,    51.8953],
          [-80.8153, 51.88],
          [-80.5992, 51.7133],
          [-80.515,  51.5244],
          [-80.4364, 51.4642],
          [-80.4244, 51.3636],
          [-80.4875, 51.3367],
          [-80.6525, 51.2783],
          [-80.7503, 51.1775],
          [-80.8447, 51.1503],
          [-80.9439, 51.0075],
          [-80.8622, 51.1161],
          [-80.6944, 51.1561],
          [-80.5306, 51.2836],
          [-80.3922, 51.3386],
          [-79.9964, 51.2547],
          [-79.7411, 51.1236],
          [-79.685,  51.0456],
          [-79.5376, 50.9586],
          [-79.5207, 48.7647],
          [-79.519,  48.6053],
          [-79.5113, 47.5656],
          [-79.5764, 47.4419],
          [-79.4394, 47.2653],
          [-79.4439, 47.1106],
          [-79.3056, 46.9405],  // idx 7 — North Bay / ONN south boundary starts
          [-79.1556, 46.8125],  // idx 8
          [-78.9506, 46.5117],  // idx 9
          [-78.7553, 46.4005],  // idx 10
          [-78.7036, 46.3372],  // idx 11
          [-77.6806, 46.1836],  // idx 12
          [-77.555,  46.1519],  // idx 13
          [-77.322,  46.0267],  // idx 14
          // Internal ONN southern boundary — must exactly match ONE's western boundary
          // Follow real Ontario boundary from idx 14 back to North Bay (idx 7)
          [-79.3056, 46.9405],  // idx 7 — North Bay
          // Then straight south to Georgian Bay apex (matching ONE's NW corner)
          [-79.69,   44.82],    // Georgian Bay apex
          [-80.40,   45.60],    // Georgian Bay inland — stay on land
          [-80.75,   45.92],    // land point
          [-81.17,   46.02],    // land
          [-81.69,   46.02],    // land
          [-82.68,   46.16],    // land - Sudbury area
          [-83.87,   46.30],    // land
          [-84.52,   46.48],    // Sault area
          [-85.00,   47.00],
          [-86.00,   47.50],
          [-87.00,   47.80],
          [-88.26,   48.99],
          [-88.48,   48.47],
          [-89.00,   48.02],
          [-89.53,   48.00],
          [-90.03,   48.09],
          [-90.86,   48.25],
          [-91.57,   48.04],
          [-92.00,   48.35],
          [-92.47,   48.36],
          [-93.30,   48.64],
          [-94.00,   48.71],
          [-94.69,   48.78],
          [-95.1543, 49.38],
          [-95.1543, 49.5767],
        ]]
      }
    },
    {
      // ONS - Ontario South (Southwestern peninsula)
      // East boundary: Hwy 400 corridor (Barrie line) lon ~-79.69
      //   from Georgian Bay apex (-79.69, 44.82) south to Lake Ontario (-79.69, 43.58)
      // South/west: real Lake Huron/Erie/St.Clair shore (idx 79→122)
      // North: straight land line from Lake Huron north to Georgian Bay apex
      type: 'Feature',
      properties: { section: 'ONS', name: 'Ontario South' },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          // Georgian Bay apex — where all three southern sections meet ONN
          [-79.69,   44.82],
          // Hwy 400 divide south to Lake Ontario (Barrie → Toronto)
          [-79.69,   43.58],    // Toronto / Lake Ontario shore
          // Real Lake Ontario / Erie / Huron south shore going west
          [-79.7758, 43.32],    // idx 79
          [-79.7036, 43.2444],  // idx 80
          [-79.3453, 43.188],   // idx 81
          [-79.074,  43.2675],  // idx 82
          [-79.0658, 43.1013],  // idx 83
          [-79.0786, 43.0817],  // idx 84
          [-79.0311, 43.0567],  // idx 85
          [-79.0408, 43.0078],  // idx 86
          [-78.9249, 42.9101],  // idx 87 — Niagara
          [-79.0989, 42.8403],  // idx 88
          [-79.4547, 42.8775],  // idx 89
          [-80.2042, 42.7903],  // idx 90
          [-80.4506, 42.6122],  // idx 91
          [-80.1144, 42.5414],  // idx 92
          [-80.5219, 42.5731],  // idx 93
          [-80.925,  42.6655],  // idx 94
          [-81.3331, 42.6514],  // idx 95
          [-81.7853, 42.3978],  // idx 96
          [-81.8564, 42.2564],  // idx 97
          [-81.8942, 42.2572],  // idx 98
          [-81.8575, 42.3208],  // idx 99
          [-81.9211, 42.2603],  // idx 100
          [-82.072,  42.2531],  // idx 101
          [-82.3881, 42.1236],  // idx 102
          [-82.4797, 42.0325],  // idx 103
          [-82.5058, 41.9133],  // idx 104
          [-82.6278, 42.0353],  // idx 105
          [-82.8906, 41.9822],  // idx 106
          [-83.1239, 42.0697],  // idx 107
          [-83.0305, 42.3132],  // idx 108
          [-82.4931, 42.3128],  // idx 109
          [-82.4272, 42.3539],  // idx 110
          [-82.4189, 42.4983],  // idx 111
          [-82.5953, 42.51],    // idx 112
          [-82.6384, 42.547],   // idx 113
          [-82.5864, 42.5586],  // idx 114
          [-82.5189, 42.6338],  // idx 115
          [-82.4733, 42.7629],  // idx 116
          [-82.472,  42.8987],  // idx 117
          [-82.4197, 42.9727],  // idx 118
          [-82.1756, 43.0717],  // idx 119
          [-81.7455, 43.3458],  // idx 120
          [-81.6978, 43.4878],  // idx 121
          [-81.745,  44.0839],  // idx 122
          [-81.6155, 44.2192],  // idx 123
          [-81.5806, 44.3467],  // idx 124
          [-81.4053, 44.4378],  // idx 125
          [-81.2681, 44.6167],  // idx 126 — stop before jagged Georgian Bay
          // Straight line north on land to Georgian Bay apex
          [-79.69,   44.82],    // close polygon at apex
        ]]
      }
    },
    {
      // GH - Golden Horseshoe
      // A wedge shape with apex at Georgian Bay where Hwy400 and Trent-Severn meet.
      // West: Hwy 400 / Barrie corridor from apex south to Lake Ontario
      // East: Trent-Severn Waterway from Lake Ontario (Trenton) NW to apex
      // South: real Lake Ontario north shore (idx 79→74)
      type: 'Feature',
      properties: { section: 'GH', name: 'Golden Horseshoe' },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          // Apex: Georgian Bay where Hwy400 meets Trent-Severn (Penetanguishene area)
          [-79.69,   44.82],
          // Hwy 400 divide south to Lake Ontario (west side of GH)
          [-79.69,   43.58],
          // Real Lake Ontario north shore going east (idx 79→74 reversed)
          [-79.7758, 43.32],    // idx 79 Hamilton/Burlington
          [-79.5878, 43.5647],  // idx 78
          [-79.4678, 43.6469],  // idx 77
          [-79.3625, 43.6433],  // idx 76
          [-79.0925, 43.8264],  // idx 75
          [-77.8047, 44.0169],  // idx 74 — Cobourg / Trent mouth area
          // Trent-Severn Waterway divide going NW back to apex
          [-77.578,  44.100],   // Trenton — mouth of Trent River on Lake Ontario
          [-78.320,  44.300],   // Peterborough
          [-78.850,  44.620],   // Balsam Lake
          [-79.720,  44.817],   // Port Severn / Georgian Bay apex
          [-79.69,   44.82],    // close polygon
        ]]
      }
    },
    {
      // ONE - Ontario East
      // West: Trent-Severn Waterway from Lake Ontario (Trenton) NW to Georgian Bay apex,
      //       then straight north to ONN (North Bay)
      // South: real Lake Ontario north shore (idx 74→34) and St Lawrence / Quebec border
      // East/North: real Ontario/Quebec border (idx 34→14)
      type: 'Feature',
      properties: { section: 'ONE', name: 'Ontario East' },
      geometry: {
        type: 'Polygon',
        coordinates: [[
          // NW: Georgian Bay apex → straight north to North Bay, then real ONN boundary
          [-79.69,   44.82],    // Georgian Bay apex (shared with ONN/ONS/GH)
          [-79.3056, 46.9405],  // idx 7 — North Bay / ONN junction (straight line north)
          [-79.1556, 46.8125],  // idx 8
          [-78.9506, 46.5117],  // idx 9
          [-78.7553, 46.4005],  // idx 10
          [-78.7036, 46.3372],  // idx 11
          [-77.6806, 46.1836],  // idx 12
          [-77.555,  46.1519],  // idx 13
          [-77.322,  46.0267],  // idx 14
          // Real Quebec/Ontario border south
          [-77.2789, 45.9378],  // idx 15
          [-77.2061, 45.8772],  // idx 16
          [-77.0028, 45.7903],  // idx 17
          [-76.9208, 45.8064],  // idx 18
          [-76.9106, 45.89],    // idx 19
          [-76.8047, 45.8647],  // idx 20
          [-76.7833, 45.7619],  // idx 21
          [-76.7106, 45.7128],  // idx 22
          [-76.6664, 45.5905],  // idx 23
          [-76.6078, 45.5525],  // idx 24
          [-76.3378, 45.4558],  // idx 25
          [-76.1844, 45.5211],  // idx 26
          [-76.0767, 45.5139],  // idx 27
          [-75.8472, 45.3725],  // idx 28
          [-75.4533, 45.5236],  // idx 29
          [-74.8758, 45.6416],  // idx 30
          [-74.6461, 45.6356],  // idx 31
          [-74.3967, 45.5642],  // idx 32
          [-74.4792, 45.3167],  // idx 33
          [-74.3247, 45.2011],  // idx 34 — St. Lawrence
          // Real St. Lawrence / Lake Ontario shore going west
          [-74.4336, 45.1494],  // idx 35
          [-74.5064, 45.0717],  // idx 36
          [-74.7365, 44.9929],  // idx 37
          [-74.9688, 44.9486],  // idx 38
          [-75.3292, 44.8106],  // idx 39
          [-75.759,  44.5175],  // idx 40
          [-75.9769, 44.3836],  // idx 43
          [-76.5031, 44.2275],  // idx 44
          [-76.6883, 44.2169],  // idx 45
          [-76.9842, 44.0714],  // idx 46
          [-77.07,   44.0922],  // idx 47
          [-76.8867, 44.1775],  // idx 48
          [-77.0467, 44.1294],  // idx 49
          [-77.0114, 44.2111],  // idx 50
          [-77.5572, 44.1214],  // idx 51
          [-77.5756, 44.0789],  // idx 52
          [-77.3144, 44.1522],  // idx 53
          [-77.3178, 44.0897],  // idx 54
          [-77.0767, 44.1794],  // idx 55
          [-77.1278, 44.0336],  // idx 56
          [-77.0158, 44.0472],  // idx 57
          [-76.9411, 44.071],   // idx 58
          [-76.8467, 44.1183],  // idx 59
          [-77.0422, 43.9483],  // idx 60
          [-76.8481, 43.9433],  // idx 61
          [-77.1345, 43.8555],  // idx 62
          [-77.2328, 43.88],    // idx 63
          [-77.1703, 43.9542],  // idx 64
          [-77.2753, 43.9105],  // idx 65
          [-77.3278, 43.9536],  // idx 66
          [-77.2547, 43.9689],  // idx 67
          [-77.4856, 43.9422],  // idx 68
          [-77.5808, 44.0028],  // idx 69
          [-77.5389, 44.0194],  // idx 70
          [-77.7036, 44.0411],  // idx 71
          [-77.7369, 44.0236],  // idx 72
          [-77.6783, 44.0008],  // idx 73
          [-77.8047, 44.0169],  // idx 74 — Cobourg / Trent mouth
          // Trent-Severn divide going NW to Georgian Bay apex (GH/ONE boundary)
          [-77.578,  44.100],   // Trenton
          [-78.320,  44.300],   // Peterborough
          [-78.850,  44.620],   // Balsam Lake
          [-79.720,  44.817],   // Port Severn
          [-79.69,   44.82],    // Georgian Bay apex — close polygon
        ]]
      }
    }
  ]
};

export default ONTARIO_SECTION_GEOJSON;
